export default {
  // general
  purchase_order: "Purchase Order",
  po_number: "PO Number",
  order_date: "Order Date",
  due_date: "Due Date",
  due_on: "Due on",
  due_on_date: "Due on {date}",
  product_count: "Product Count",
  quantity: "Quantity",
  status: "Status",
  remaining_quantity: "Remaining quantity",
  completed: "Completed {percentage}%",
  sent_on: "Sent on {date}",

  // actions
  create_new_order: "Create new order",
  send_dialog_title: "Send order {po_number}",
  sync_dialog_title: "Synchronize purchase orders",
  yes_send_now: "Yes, send now",
  save_quit: "Save and Quit",

  // search
  search_po: "Search PO number",
  search_pos: "Search POs",
  select_all: "Select all",
  no_po_found: "No purchase order found.",

  // messages
  send_dialog_are_you_sure: "Are you sure you want to send this order?",
  synchronize_button: "Synchronize selected ({amount})",

  // errors
  nothing_to_sync: "There are no open purchase orders for this report.",
  send_dialog_invalid_refs:
    "This purchase order contains invalid {invalid_refs} SKU(s). You will be notified when those have been added to our product library.",

  // invalid ref
  invalid_refs: "Unknown SKUs",
  invalid_refs_tooltip: "This order has {invalid_refs} unknown SKU(s).",

  // order import
  import_csv: "Import CSV",
  import_products: "Import products",
  importing: "Importing...",
  import_tally:
    "You have successfully imported collections ({collections} new), products ({products} new) and variants ({variants} new)"
};
